import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { LoadingButton } from '@mui/lab';
import { Button } from '@mui/material';

const AIChat = () => {
    const [botProfile, setBotProfile] = useState('');
    const [loading, setLoading] = useState(false);
    const [hasChanges, setHasChanges] = useState(false);

    const fetchBotProfile = async () => {
        try {
            const response = await axios.get('https://us-central1-awesome-radi-languages.cloudfunctions.net/getChatBotFile');
            setBotProfile(response.data.contenido);
        } catch (error) {
            console.error('Error al obtener el perfil del bot:', error);
        }
    };

    const handleProfileChange = (content: string) => {
        setBotProfile(content);
        setHasChanges(true);
    };

    const saveBotProfile = async () => {
        setLoading(true);
        try {
          await axios.post(
            "https://us-central1-awesome-radi-languages.cloudfunctions.net/setChatBotFile",
            {
              contenido: botProfile,
            }
          );
          setHasChanges(false);
          alert(`Contenido guardado exitosamente.`);
        } catch (error) {
            console.error('Error al guardar el perfil del bot:', error);
            alert('Error al guardar el contenido');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchBotProfile();
    }, []);

    return (
        <div className='shadow-md border rounded-2xl p-6 bg-white max-w-[800px] w-full'>
            <div className='space-y-6'>
                <div className='font-bold text-2xl'>Perfil del Bot de Whatsapp</div>
                <div className='space-y-4'>
                    <div className='space-y-2'>
                        <div className='font-bold text-lg'>Descripción del Bot</div>
                        <div className='text-base'>Instrucciones generales que debe seguir el bot</div>
                        <div className='outline-none rounded-lg border border-gray-400 min-h-[500px] overflow-y-auto flex'>
                            <textarea
                                className='outline-none p-4 grow'
                                value={botProfile}
                                onChange={e => handleProfileChange(e.target.value)}
                            />
                        </div>
                    </div>
                </div>
                <div className='flex flex-col justify-center space-y-2 desktop:space-y-0 desktop:flex-row desktop:justify-end desktop:space-x-2'>
                    <Button
                        variant="outlined"
                        size="large"
                        onClick={() => {
                          window.open('https://console.twilio.com/us1/develop/sms/senders/whatsapp-senders/XE4dd685ec42df688381947c71c3e134ed', "_blank");
                        }}
                    >
                        Configurar en Twilio
                    </Button>
                    <Button
                        variant="outlined"
                        size="large"
                        disabled={hasChanges}
                        onClick={() => {
                          const phoneNumber = "+12566074845";
                          const url = `https://wa.me/${phoneNumber}`;
                          window.open(url, "_blank");
                        }}
                    >
                        Probar chat bot
                    </Button>
                    <LoadingButton
                        loading={loading}
                        variant="contained"
                        size="large"
                        onClick={saveBotProfile} 
                        disabled={loading || !hasChanges}
                    >
                        Guardar
                    </LoadingButton>
                </div>
            </div>
        </div>
    );
};

export { AIChat };